import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, noop } from 'rxjs';
import { FiberService } from 'src/app/services/fiber.service';
import { NavigationService } from 'src/app/services/navigation.service';

interface RouterData {
    headerLayout?: 'classic' | 'compact';
}

@Component({
    selector: 'app-main',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.scss']
})
export class RootComponent {
    headerLayout: 'classic' | 'compact' = 'classic';
    isLoggedIn: boolean = false
    isCheckcoveragePage: boolean = false;
    isMobile: boolean = false;
    isFullmenu: boolean = true
    changepassword=false
    constructor(
        public route: ActivatedRoute,
        private router: Router,
        private navigate: NavigationService,
        private _fiberService: FiberService
    ) {
        this.route.data.subscribe((data: RouterData) => {
            this.headerLayout = data.headerLayout || 'classic';
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: any) => {
                console.log("eventttt-----",event);
                if (event.url==='login' || event.url.includes('register') || localStorage.getItem('token') === null) {
                    
                    localStorage.removeItem('token');
                    localStorage.setItem('isLoggedIn', 'false')
                    this.isLoggedIn = false;
                    if (event.url.includes('checkcoverage')) this.isCheckcoveragePage = true;
                    else if (event.url.includes('password')) this.changepassword = true;
                    else{ 
                        this.isCheckcoveragePage = false
                        this.changepassword=false
                    }
                } else  if (event.url != '/'){
                    localStorage.setItem('isLoggedIn', 'true')
                    this.isLoggedIn = true;
                    // this._fiberService.getMenuByRole(3).subscribe(noop);
                    this.isCheckcoveragePage = false
                    this.changepassword=false
                }
            });
    }



    signin(){
        this.navigate.login();
    }

    getMenuViewStatus(event) {
     this.isFullmenu = event
    }

}
